
















































































































import loading from '@/components/loading.vue';
import addTypeDialog from '@/components/settings/types/add-type-dialog.vue';
import editTypeDialog from '@/components/settings/types/edit-type-dialog.vue';
import { AdditionalDocumentType } from '@/shared/types/additional-document-type';
import { AppointmentCancellationType } from '@/shared/types/appointment-cancellation-type';
import { AppointmentExecutorType } from '@/shared/types/appointment-executor-type';
import { AppointmentNoInstructionType } from '@/shared/types/appointment-no-instruction-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { AppointmentReasonType } from '@/shared/types/appointment-reason-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientRelationshipType } from '@/shared/types/client-relationship-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { ClientTitleType } from '@/shared/types/client-title-type';
import { GenericType } from '@/shared/types/generic-type';
import { InteractionLetterType } from '@/shared/types/interaction-letter-type';
import { InteractionOutcomeType } from '@/shared/types/interaction-outcome-type';
import { InteractionType } from '@/shared/types/interaction-type';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { WillType } from '@/shared/types/will-type';
import { camelCase } from '@/string-utilities';
import { Component, Vue, Watch } from 'vue-property-decorator';
// @ts-ignore
import draggable from 'vuedraggable';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component({
    components: {
        loading,
        addTypeDialog,
        editTypeDialog,
        draggable,
    },
})
export default class Types extends Vue {
    @typesModule.Getter('additionalDocumentTypes') public additionalDocumentTypes!: Array<AdditionalDocumentType>;
    @typesModule.Getter('appointmentCancellationTypes') public appointmentCancellationTypes!: Array<AppointmentCancellationType>;
    @typesModule.Getter('appointmentExecutorTypes') public appointmentExecutorTypes!: Array<AppointmentExecutorType>;
    @typesModule.Getter('appointmentReasonTypes') public appointmentReasonTypes!: Array<AppointmentReasonType>;
    @typesModule.Getter('appointmentNoInstructionTypes') public appointmentNoInstructionTypes!: Array<AppointmentNoInstructionType>;
    @typesModule.Getter('appointmentOutcomeTypes') public appointmentOutcomeTypes!: Array<AppointmentOutcomeType>;
    @typesModule.Getter('appointmentPaymentStatusTypes') public appointmentPaymentStatusTypes!: Array<AppointmentPaymentStatusType>;
    @typesModule.Getter('appointmentProductTypes') public appointmentProductTypes!: Array<AppointmentProductType>;
    @typesModule.Getter('appointmentTypes') public appointmentTypes!: Array<AppointmentType>;
    @typesModule.Getter('clientOriginalSourceTypes') public clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;
    @typesModule.Getter('clientRelationshipTypes') public clientRelationshipTypes!: Array<ClientRelationshipType>;
    @typesModule.Getter('clientStatusTypes') public clientStatusTypes!: Array<ClientStatusType>;
    @typesModule.Getter('clientTitleTypes') public clientTitleTypes!: Array<ClientTitleType>;
    @typesModule.Getter('interactionLetterTypes') public interactionLetterTypes!: Array<InteractionLetterType>;
    @typesModule.Getter('interactionOutcomeTypes') public interactionOutcomeTypes!: Array<InteractionOutcomeType>;
    @typesModule.Getter('interactionTypes') public interactionTypes!: Array<InteractionType>;
    @typesModule.Getter('powerOfAttorneyTypes') public powerOfAttorneyTypes!: Array<PowerOfAttorneyType>;
    @typesModule.Getter('willTypes') public willTypes!: Array<WillType>;

    private categories: Array<string> = [
        'Appointment',
        'Client',
        'Interaction',
        'Will',
        'Power of Attorney',
    ];

    private types: Array<{ category: string, id: string, title: string, options?: Array<{ text: string, value: string, unique: boolean }> }> = [
        {
            category: 'Appointment', id: 'appointment', title: 'Appointment Types', options: [
                { text: 'Is Location Required', value: 'isLocationRequired', unique: false },
                { text: 'Is Initial Appointment', value: 'isInitialAppointment', unique: true },
                { text: 'Is Signing Appointment', value: 'isSigningAppointment', unique: true },
            ],
        },
        {
            category: 'Appointment', id: 'appointment cancellation', title: 'Appointment Cancellation Types', options: [
                { text: 'Is No Longer Interested', value: 'isNoLongerInterested', unique: true },
                { text: 'Is Additional Commitments', value: 'isAdditionalCommitments', unique: true },
                { text: 'Is Sickness', value: 'isSickness', unique: true },
            ],
        },
        {
            category: 'Appointment', id: 'appointment executor', title: 'Appointment Executor Types', options: [
                { text: 'Is Professional Executor', value: 'isProfessionalExecutor', unique: false },
            ],
        },
        { category: 'Appointment', id: 'appointment no instruction', title: 'Appointment No Instruction Types' },
        {
            category: 'Appointment', id: 'appointment outcome', title: 'Appointment Outcome Types', options: [
                { text: 'Is Sat', value: 'isSat', unique: false },
                { text: 'Is Not Sat', value: 'isNotSat', unique: false },
                { text: 'Is Cancelled', value: 'isCancelled', unique: false },
            ],
        },
        {
            category: 'Appointment', id: 'appointment payment status', title: 'Appointment Payment Status Types', options: [
                { text: 'Is Signing Pending', value: 'isSigningPending', unique: true },
                { text: 'Is Signing Booked', value: 'isSigningBooked', unique: true },
                { text: 'Is Banked', value: 'isBanked', unique: true },
                { text: 'Is Cleared', value: 'isCleared', unique: true },
                { text: 'Is Part Payment', value: 'isPartPayment', unique: true },
                { text: 'Is Debtor', value: 'isDebtor', unique: true },
                { text: 'Is No Longer Proceeding', value: 'isNoLongerProceeding', unique: true },
                { text: 'Is Written Off', value: 'isWrittenOff', unique: true },
                { text: 'Is Complete', value: 'isComplete', unique: false },
                { text: 'Is Admin Only', value: 'isAdminOnly', unique: false },
            ],
        },
        {
            category: 'Appointment', id: 'appointment product', title: 'Appointment Product Types', options: [
                { text: 'Is Will', value: 'isWill', unique: true },
                { text: 'Is LPA', value: 'isLpa', unique: true },
            ],
        },
        { category: 'Appointment', id: 'appointment reason', title: 'Appointment Reason Types' },
        {
            category: 'Client', id: 'additional document', title: 'Additional Document Types', options: [
                { text: 'Is Other Text Required', value: 'isOtherTextRequired', unique: false },
            ],
        },
        {
            category: 'Client', id: 'client original source', title: 'Client Introducer Types', options: [
                { text: 'Is Valid For RLG Data', value: 'isValidForAcquisition', unique: false },
            ],
        },
        { category: 'Client', id: 'client relationship', title: 'Client Relationship Types' },
        {
            category: 'Client', id: 'client status', title: 'Client Status Types', options: [
                { text: 'Is Client', value: 'isClient', unique: true },
                { text: 'Is Lead', value: 'isLead', unique: true },
                { text: 'Is Business Will Client', value: 'isBusinessWillClient', unique: true },
                { text: 'Is Deceased', value: 'isDeceased', unique: true },
                { text: 'Is Archived', value: 'isAccountArchived', unique: true },
            ],
        },
        { category: 'Client', id: 'client title', title: 'Client Title Types' },
        {
            category: 'Interaction', id: 'interaction', title: 'Interaction Types', options: [
                { text: 'Is Call Outcome Required', value: 'isCallOutcomeRequired', unique: false },
                { text: 'Is Letter Type Required', value: 'isLetterTypeRequired', unique: false },
                { text: 'Is LFTSY', value: 'isLFTSY', unique: true },
                { text: 'Is Call Made', value: 'isCallMade', unique: true },
                { text: 'Is Call Received', value: 'isCallReceived', unique: true },
            ],
        },
        {
            category: 'Interaction', id: 'interaction letter', title: 'Interaction Letter Types', options: [
                { text: 'Is First Contact', value: 'isFirstContact', unique: true },
                { text: 'Is Second Contact', value: 'isSecondContact', unique: true },
                { text: 'Is Third Contact', value: 'isThirdContact', unique: true },
            ],
        },
        {
            category: 'Interaction', id: 'interaction outcome', title: 'Interaction Outcome Types', options: [
                { text: 'Is Call Made Outcome', value: 'isCallMadeOutcome', unique: false },
                { text: 'Is Call Received Outcome', value: 'isCallReceivedOutcome', unique: false },
                { text: 'Is LFTSY Outcome', value: 'isLFTSYOutcome', unique: false },
                { text: 'Is Callback', value: 'isCallback', unique: false },
                { text: 'Is Appointment Booked', value: 'isAppointmentBooked', unique: false },
                { text: 'Is Appointment Re-booked', value: 'isAppointmentRebooked', unique: false },
                { text: 'Is Appointment Confirmed', value: 'isAppointmentConfirmed', unique: false },
                { text: 'Is Appointment Cancelled', value: 'isAppointmentCancelled', unique: false },
                { text: 'Is Deceased', value: 'isDeceased', unique: false },
                { text: 'Is Unable to Contact', value: 'isUnableToContact', unique: true },
                { text: 'Is Do Not Contact', value: 'isDoNotContact', unique: true },
                { text: 'Is Allow Contact', value: 'isAllowContact', unique: true },
                { text: 'Is Call in Two Years', value: 'isCallInTwoYears', unique: true },
                { text: 'Is Wrong Number', value: 'isWrongNumber', unique: true },
                { text: 'Is Will Void', value: 'isWillVoid', unique: true },
                { text: 'Is Will Released', value: 'isWillReleased', unique: true },
            ],
        },
        { category: 'Will', id: 'will', title: 'Will Types' },
        {
            category: 'Power of Attorney', id: 'power of attorney', title: 'Power of Attorney Types', options: [
                { text: 'Is Exclusive', value: 'isExclusive', unique: true },
                { text: 'Is Unknown', value: 'isUnknown', unique: true },
            ],
        },
    ];

    private statuses: Array<{ id: number, title: string }> = [
        { id: 0, title: 'All' },
        { id: 1, title: 'Active' },
        { id: 2, title: 'Archived' },
    ];

    private isLoading: boolean = true;
    private categoryFilter: string = 'Appointment';
    private typeIdFilter: string | null = 'appointment';
    private statusFilter: number = 1;
    private selectedTypeValues: Array<GenericType> = [];
    private selectedTypeValue: GenericType | null = null;
    private selectedTypeOptions: Array<{ text: string, value: string }> = [];
    private addTypeDialogVisible: boolean = false;
    private editTypeDialogVisible: boolean = false;
    private deleteConfirmationDialogVisible: boolean = false;
    private restoreConfirmationDialogVisible: boolean = false;

    private get filteredTypeValues(): Array<GenericType> {
        switch (this.statusFilter) {
            case 1:
                return this.selectedTypeValues.filter((v) => !v.isArchived);
            case 2:
                return this.selectedTypeValues.filter((v) => v.isArchived);
            default:
                return this.selectedTypeValues;
        }
    }

    @Watch('additionalDocumentTypes')
    private onAdditionalDocumentTypesChanged(newValues: Array<AdditionalDocumentType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentCancellationTypes')
    private onAppointmentCancellTypesChanged(newValues: Array<AppointmentCancellationType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentExecutorTypes')
    private onAppointmentExecutorTypesChanged(newValues: Array<AppointmentExecutorType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentReasonTypes')
    private onAppointmentReasonTypesChanged(newValues: Array<AppointmentReasonType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentNoInstructionTypes')
    private onAppointmentNoInstructionTypesChanged(newValues: Array<AppointmentNoInstructionType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentOutcomeTypes')
    private onAppointmentOutcomeTypesChanged(newValues: Array<AppointmentOutcomeType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentPaymentStatusTypes')
    private onAppointmentPaymentStatusTypesChanged(newValues: Array<AppointmentPaymentStatusType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentProductTypes')
    private onAppointmentProductTypesChanged(newValues: Array<AppointmentProductType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('appointmentTypes')
    private onAppointmentTypesChanged(newValues: Array<AppointmentType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('clientOriginalSourceTypes')
    private onClientOriginalSourceTypesChanged(newValues: Array<ClientOriginalSourceType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('clientRelationshipTypes')
    private onClientRelationshipTypesChanged(newValues: Array<ClientRelationshipType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('clientStatusTypes')
    private onClientStatusTypesChanged(newValues: Array<ClientStatusType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('clientTitleTypes')
    private onClientTitleTypesChanged(newValues: Array<ClientTitleType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('interactionLetterTypes')
    private onInteractionLetterTypesChanged(newValues: Array<InteractionLetterType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('interactionOutcomeTypes')
    private onInteractionOutcomeTypesChanged(newValues: Array<InteractionOutcomeType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('interactionTypes')
    private onInteractionTypesChanged(newValues: Array<InteractionType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('willTypes')
    private onWillTypesChanged(newValues: Array<WillType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('powerOfAttorneyTypes')
    private onPowerOfAttorneyTypesChanged(newValues: Array<PowerOfAttorneyType>): void {
        this.selectedTypeValues = [...newValues];
    }

    @Watch('categoryFilter')
    private onCategoryFilterChanged(newValue: string): void {
        const types = this.typesForCategory(newValue);
        this.typeIdFilter = types == null || !types.length ? null : types[0].id;
    }

    @Watch('typeIdFilter')
    private async onTypeIdFilterChanged(): Promise<void> {
        await this.loadTypeValuesAsync();
    }

    private async onAddAsync(item: { value: string, [key: string]: any }): Promise<void> {
        try {
            await this.$store.dispatch(`types/createTypeAsync`, { type: this.typeIdFilter, item: { ...item } });
            this.$snackbar.open({ message: `Type '${item.value}' has been successfully created.`, type: 'is-success' });
        } catch (e) {
            this.$snackbar.open({ message: `Could not create the new type value '${item.value}'. Please try again.`, type: 'is-danger' });
        }

        this.onCancel();
        await this.loadTypeValuesAsync();
    }

    private async onEditAsync(item: { [key: string]: any }): Promise<void> {
        try {
            await this.$store.dispatch(`types/updateTypeAsync`, { type: this.typeIdFilter, item: { ...item } });
            this.$snackbar.open({ message: `Type '${this.selectedTypeValue!.value}' has been successfully updated.`, type: 'is-success' });
        } catch (e) {
            this.$snackbar.open({ message: `Could not update the type value '${this.selectedTypeValue!.value}'. Please try again.`, type: 'is-danger' });
        }

        this.onCancel();
        await this.loadTypeValuesAsync();
    }

    private async onArchiveAsync(): Promise<void> {
        try {
            await this.$store.dispatch(`types/archiveTypeAsync`, { type: this.typeIdFilter, item: { ...this.selectedTypeValue! } });
            this.$snackbar.open({ message: `Type '${this.selectedTypeValue!.value}' has been successfully archived.`, type: 'is-success' });
        } catch (e) {
            this.$snackbar.open({ message: `Could not archive the type value '${this.selectedTypeValue!.value}'. Please try again.`, type: 'is-danger' });
        }

        this.onCancel();
        await this.loadTypeValuesAsync();
    }

    private async onRestoreAsync(): Promise<void> {
        try {
            await this.$store.dispatch(`types/updateTypeAsync`, { type: this.typeIdFilter, item: { ...this.selectedTypeValue, isArchived: false } });
            this.$snackbar.open({ message: `Type '${this.selectedTypeValue!.value}' has been successfully restored.`, type: 'is-success' });
        } catch (e) {
            this.$snackbar.open({ message: `Could not restore the type value '${this.selectedTypeValue!.value}'. Please try again.`, type: 'is-danger' });
        }

        this.onCancel();
        await this.loadTypeValuesAsync();
    }

    private async onReorderedAsync(e: { newIndex: number, oldIndex: number }): Promise<void> {
        const selectedValue = { ...this.selectedTypeValues[e.newIndex] };
        const moveUp: boolean = e.newIndex < e.oldIndex;
        const siblingValue = this.selectedTypeValues[moveUp ? e.newIndex + 1 : e.newIndex - 1];

        if (siblingValue == null) {
            return;
        }

        try {
            await this.$store.dispatch(`types/updateTypeAsync`, { type: this.typeIdFilter, item: { ...selectedValue, displayOrder: siblingValue.displayOrder! } });
            this.$snackbar.open({ message: 'Display order updated successfully.', type: 'is-success' });
        } catch (e) {
            this.$snackbar.open({ message: 'Could not update the display order for all values.', type: 'is-danger' });
        }

        await this.loadTypeValuesAsync();
    }

    private async loadTypeValuesAsync(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(`types/${camelCase(`load ${this.typeIdFilter}TypesAsync`)}`);
        this.isLoading = false;
    }

    private addNewItem(): void {
        this.selectedTypeOptions = this.types.find((t) => t.id === this.typeIdFilter)!.options!;
        this.addTypeDialogVisible = true;
    }

    private editItem(item: GenericType) {
        this.selectedTypeValue = { ...item };
        this.selectedTypeOptions = this.types.find((t) => t.id === this.typeIdFilter)!.options!;
        this.editTypeDialogVisible = true;
    }

    private archiveItem(item: GenericType) {
        this.selectedTypeValue = { ...item };
        this.deleteConfirmationDialogVisible = true;
    }

    private restoreItem(item: GenericType) {
        this.selectedTypeValue = { ...item };
        this.restoreConfirmationDialogVisible = true;
    }

    private onCancel(): void {
        this.selectedTypeValue = null;

        this.addTypeDialogVisible = false;
        this.editTypeDialogVisible = false;
        this.deleteConfirmationDialogVisible = false;
        this.restoreConfirmationDialogVisible = false;
    }

    private typesForCategory(category: string): Array<{ id: string, title: string }> {
        if (this.types == null || !this.types.length) {
            return [];
        }

        const types = this.types.filter((t) => t.category === category);

        return types == null ? [] : types;
    }

    public async mounted(): Promise<void> {
        await this.loadTypeValuesAsync();
    }
}
